import Button from '@material-ui/core/Button'
import {Trans} from 'react-i18next'
import messages from '../../../../assets/messages'
import {getFormattedAmount} from '../../../../common/utils/general'
import {OfferBody} from '../../../Accounts/PammManagerSettingsView/components/PammManagerOffers/components/OfferTile/components/OfferBody'
import {Condition} from './components/Condition'
import {Conditions} from './components/Conditions'
import {Container} from './components/Container'
import {Name} from './components/Name'
import {TopLine} from './components/TopLine'
import {TopLineLeft} from './components/TopLineLeft'
import {PammOfferType} from '../../../../graphql/types'
import {WithCopyToClipboard} from '../../../Common/WithCopyToClipboard'
import {config} from '../../../../config'

type PammAgentOfferProps = {
  offer: PammOfferType
}

export const PammAgentOffer = ({offer}: PammAgentOfferProps) => {
  const joinLink = `${config.frontendUrl}?pammManager=${offer.skygroundAccountId}&pammOffer=${offer.id}`
  return (
    <Container>
      <TopLine>
        <TopLineLeft>
          <Name>{offer.name}</Name>
          <Conditions>
            <Condition>
              <Trans {...messages.totalInvestors} />: {offer.activeInvestmentCount}
            </Condition>
            <Condition>
              <Trans {...messages.agentId} />: {offer.settings?.agentChain?.[0]?.agentId}
            </Condition>
            <Condition>
              <Trans
                {...messages.moneyManager}
                values={{
                  name: `${offer.managerId} - ${offer.managerName}`,
                }}
              />
            </Condition>
            <Condition>
              <Trans {...messages.totalInvestments} />:{' '}
              {getFormattedAmount({amount: offer.totalDepositSum, currency: offer.currency})}
            </Condition>
          </Conditions>
        </TopLineLeft>
        <WithCopyToClipboard text={joinLink}>
          <Button color="primary" variant="contained">
            <Trans {...messages.copyLink} />
          </Button>
        </WithCopyToClipboard>
      </TopLine>
      <OfferBody offer={offer} />
    </Container>
  )
}
